import { principles, testimonials } from "@/mocks/melonData";
import { SectionHeading, SectionShell, SITE_NAME } from "./brand";

export default function About() {
  return (
    <SectionShell id="about">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_420px]">
        {/* 左侧品牌故事 */}
        <div>
          <SectionHeading
            eyebrow="关于我们 · 把瓜看准的编辑部"
            title={`${SITE_NAME}，做吃瓜界的「把关人」`}
            desc="一个把爆料求证、可信度实锤与辟谣做扎实的内容社区。"
          />

          <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            <p>
              <strong className="text-foreground-950">品牌介绍</strong>
              ：我们是一群吃瓜吃伤过的老网民组成的志愿者编辑团队。见得多了，就更明白——
              热搜上的「反转」往往不是事件在变，而是信息被一层层剪过。于是我们创办了{ SITE_NAME }
              ，专门把碎成一地的爆料重新拼起来，让你看清原貌。
            </p>
            <p>
              <strong className="text-foreground-950">网站定位</strong>
              ：不抢首发，不追情绪流量。我们的唯一 KPI 是「让误判变少」——
              聚合爆料可信度、拆解实锤过程、跟进辟谣与二次复核，做吃瓜前的最后一道过滤。
            </p>
            <p>
              <strong className="text-foreground-950">发展理念</strong>
              ：我们相信，真正把瓜吃明白的人不会急着站队。以证据链而非立场说话，
              给当事双方同等反驳窗口，也坦然承认「还没查到」——这份克制，就是我们存在的理由。
            </p>
          </div>

          <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
            {principles.map((pr) => (
              <div
                key={pr.title}
                className="rounded-2xl border border-background-200 bg-background-100 p-4"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-lg">
                  <i className={pr.icon} />
                </span>
                <h3 className="mt-3 text-sm font-semibold text-foreground-950">
                  {pr.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">
                  {pr.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* 右侧口碑 */}
        <aside>
          <div className="rounded-2xl border border-background-200 bg-background-100 p-6 lg:sticky lg:top-24">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-semibold text-foreground-950">吃瓜群众的实话</h3>
              <i className="ri-heart-3-line text-xl text-primary-500" />
            </div>
            <div className="mt-5 space-y-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="rounded-xl border border-background-200 bg-background-50 p-4"
                >
                  <div className="flex items-center gap-1 text-primary-400">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs" />
                    ))}
                  </div>
                  <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                    “{t.text}”
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-2">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700 text-sm">
                      <i className={t.icon} />
                    </span>
                    <div>
                      <p className="text-xs font-semibold text-foreground-950">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
            <a
              href="#contact"
              className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-sm text-background-50 hover:bg-primary-600"
            >
              想聊聊你的看法？
              <i className="ri-chat-smile-3-line" />
            </a>
          </div>
        </aside>
      </div>
    </SectionShell>
  );
}